export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6614.330d7ebd.jpg";